import { createContext } from "react";

export type UserProfile = {
  user_id: string;
  dark_mode: boolean;
  lang: "en" | "fr";
  created_at: string;
  updated_at: string;
};

export interface UserProfileContextType {
  profile: UserProfile | null;
  loading: boolean;
  updateProfile: (
    updates: Partial<Pick<UserProfile, "dark_mode" | "lang">>,
  ) => Promise<void>;
}

export const UserProfileContext = createContext<
  UserProfileContextType | undefined
>(undefined);
